import { render } from "./CreateRequestView.vue?vue&type=template&id=52dfe7b4&scoped=true"
import script from "./CreateRequestView.vue?vue&type=script&lang=js"
export * from "./CreateRequestView.vue?vue&type=script&lang=js"

import "./CreateRequestView.vue?vue&type=style&index=0&id=52dfe7b4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52dfe7b4"]])

export default __exports__